// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-layout {
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  width: 100%;
}

.app-body {
  flex: 1 1 0;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.app-body ::ng-deep router-outlet + * {
  flex: 1 1 auto;
  overflow: auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.app-header {
  flex-shrink: 0;
  background: #fff !important;
  padding: 10px 30px;
  border-bottom: 1px solid #eee;
  width: 100%;
  z-index: 1000;
}
.app-header::before, .app-header::after {
  display: none !important;
  background: none !important;
}

.header-content {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  width: 100%;
}

.header-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.header-center .chevron-logo {
  height: 80px;
}
.header-center .app-name {
  margin-bottom: 5px;
  font-size: 18px;
  font-weight: 600;
  letter-spacing: 0.3px;
  color: #009DD9;
}

.header-user {
  display: flex;
  justify-content: flex-end;
}
.header-user .logged-in-email {
  font-size: 16px;
}

::ng-deep np-menu {
  flex-shrink: 0 !important;
  display: block !important;
}

::ng-deep np-menu nav,
::ng-deep np-menu .nav,
::ng-deep np-menu ul {
  min-height: unset !important;
  height: auto !important;
}

::ng-deep np-menu nav a,
::ng-deep np-menu .nav-item,
::ng-deep np-menu li,
::ng-deep np-menu ul li a {
  padding-top: 6px !important;
  padding-bottom: 6px !important;
  line-height: 1.2 !important;
}

footer {
  flex-shrink: 0;
  width: 100%;
  z-index: 1000;
}
footer ul {
  margin: 0;
  padding: 0;
}

.loading-container {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
}`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/app.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AACF;AACE;EACE,cAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;AACJ;;AAGA;EACE,cAAA;EACA,2BAAA;EACA,kBAAA;EACA,6BAAA;EACA,WAAA;EACA,aAAA;AAAF;AAEE;EAEE,wBAAA;EACA,2BAAA;AADJ;;AAKA;EACE,aAAA;EACA,mCAAA;EACA,mBAAA;EACA,WAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAFF;AAIE;EACE,YAAA;AAFJ;AAKE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;AAHJ;;AAOA;EACE,aAAA;EACA,yBAAA;AAJF;AAME;EACE,eAAA;AAJJ;;AAQA;EACE,yBAAA;EACA,yBAAA;AALF;;AAQA;;;EAGE,4BAAA;EACA,uBAAA;AALF;;AAQA;;;;EAIE,2BAAA;EACA,8BAAA;EACA,2BAAA;AALF;;AAQA;EACE,cAAA;EACA,WAAA;EACA,aAAA;AALF;AAOE;EACE,SAAA;EACA,UAAA;AALJ;;AASA;EACE,mBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,aAAA;AANF","sourcesContent":[".app-layout {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n  overflow: hidden;\n  width: 100%;\n}\n\n.app-body {\n  flex: 1 1 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n\n  ::ng-deep router-outlet+* {\n    flex: 1 1 auto;\n    overflow: auto;\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n  }\n}\n\n.app-header {\n  flex-shrink: 0;\n  background: #fff !important;\n  padding: 10px 30px;\n  border-bottom: 1px solid #eee;\n  width: 100%;\n  z-index: 1000;\n\n  &::before,\n  &::after {\n    display: none !important;\n    background: none !important;\n  }\n}\n\n.header-content {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: center;\n  width: 100%;\n}\n\n.header-center {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n\n  .chevron-logo {\n    height: 80px;\n  }\n\n  .app-name {\n    margin-bottom: 5px;\n    font-size: 18px;\n    font-weight: 600;\n    letter-spacing: 0.3px;\n    color: #009DD9;\n  }\n}\n\n.header-user {\n  display: flex;\n  justify-content: flex-end;\n\n  .logged-in-email {\n    font-size: 16px;\n  }\n}\n\n::ng-deep np-menu {\n  flex-shrink: 0 !important;\n  display: block !important;\n}\n\n::ng-deep np-menu nav,\n::ng-deep np-menu .nav,\n::ng-deep np-menu ul {\n  min-height: unset !important;\n  height: auto !important;\n}\n\n::ng-deep np-menu nav a,\n::ng-deep np-menu .nav-item,\n::ng-deep np-menu li,\n::ng-deep np-menu ul li a {\n  padding-top: 6px !important;\n  padding-bottom: 6px !important;\n  line-height: 1.2 !important;\n}\n\nfooter {\n  flex-shrink: 0;\n  width: 100%;\n  z-index: 1000;\n\n  ul {\n    margin: 0;\n    padding: 0;\n  }\n}\n\n.loading-container {\n  align-items: center;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  height: 100vh;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
